var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconSmartsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.265627 4.11718C-0.203123 3.17968 -0.0390604 2.04687 0.67969 1.28125C1.39844 0.515621 2.51563 0.289059 3.48438 0.695309L38.4844 15.6953C39.4063 16.0859 40 16.9922 40 17.9922C40 18.9922 39.4063 19.8984 38.4844 20.2891L3.48438 35.2891C2.52344 35.7031 1.39844 35.4687 0.67969 34.7031C-0.0390604 33.9375 -0.203123 32.8047 0.265627 31.8672L7.20313 18L0.265627 4.11718ZM9.375 19.25L2.5 33L34.5859 19.25H9.375ZM34.5859 16.75L2.5 3L9.375 16.75H34.5859Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconSmartsg);
export default __webpack_public_path__ + "static/media/search-icon-smartsg.aa6c444322e4de6410dd9d36dae0aa90.svg";
export { ForwardRef as ReactComponent };